<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col sm="6">
        <div class="text-center">
          <img src="img/waf_level.png"
            class="text-center"
            style="margin-left: auto; margin-right: auto;width: auto; height:150px;"
          >
        </div>
      </b-col>
      <b-col sm="6">
        <p :style="`${server.level >= 4 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 4 is detect by policy level 1 ~ 4 </p>
        <p :style="`${server.level >= 3 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 3 is detect by policy level 1 ~ 3 </p>
        <p :style="`${server.level >= 2 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 2 is detect by policy level 1 ~ 2 </p>
        <p :style="`${server.level >= 1 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 1 is detect by policy level 1 </p>
        <hr>
        <p>
          The higher the level, the deeper the attack is detected.
        </p>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="2">Setting by Default <br><small>Click to change</small></b-col>
      <b-col sm="3" style="cursor: pointer;" @click="server.level = server.level < 4 ? server.level + 1 : 1">
        <strong style="cursor: pointer;">Policy Security Level</strong>
        <small style="cursor: pointer;">( Level : {{server.level}} )</small>
      </b-col>
      <b-col sm="3" style="cursor: pointer;">
        <b-form-radio-group @change="update($event, 'level')" style="cursor: pointer;" id="ph_level" v-model="server.level" :options="codes.WAF_LEVEL"></b-form-radio-group>
      </b-col>
      <b-col sm="3" class="text-center" style="cursor: pointer;">
        <strong @click="change">Firewall Mode :
          <b-badge style="cursor: pointer;" v-if="server.mode == 0" variant="secondary">Off</b-badge>
          <b-badge style="cursor: pointer;" v-if="server.mode == 1" variant="warning">DetectionOnly</b-badge>
          <b-badge style="cursor: pointer;" v-if="server.mode == 2" variant="danger">Block</b-badge>
        </strong>
        <!-- <b-form-radio-group id="ph_mode" v-model="server.mode" :options="codes.WAF_MODE"> </b-form-radio-group> -->
      </b-col>
      <b-col sm="2"></b-col>
      <!-- <b-col md="3">
        <div class="pull-right">
          <b-button size="sm" variant="success" @click="rule_confirm = true">Apply</b-button>
          <b-button size="sm" variant="warning" @click="apply_modal = true">Apply to other servers</b-button>
        </div>
      </b-col> -->
    </b-row>
    <hr>
    <b-row class="text-left">
      <b-col>
        <b-form-group>
          <h5>
            <b-badge variant="success">Notice</b-badge>
            <small> <strong>
              If you set the immediate level high, there may be service problems. Recommended setting firewall level 4 with long-term plan
            </strong></small>
            <hr>
            <small> <strong> * Off : Disable WEBCastle function for the currently selected domain </strong></small><br>
            <small> <strong> * <b-badge variant="warning">DetectionOnly</b-badge> : Detect Only while on Activation </strong></small><br>
            <small> <strong> * <b-badge variant="danger">On</b-badge> : Block While On Activation (Not recommended for initial setup) </strong></small>
          </h5>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
